module.exports = __webpack_public_path__ + "static/media/Sep_2025_4.0417a738.webp";